import React from 'react';

interface UseUncontrolledInput<T> {
	value?: T;
	defaultValue?: T;
	finalValue?: T;
	onChange?(value: T): void;
}

/**
 * Hook allowing to use an input as a non-controlled component
 * @param param0 Hook options
 * @returns
 */
export function useUncontrolled<T>({
	value,
	defaultValue,
	finalValue,
	onChange = () => {},
}: UseUncontrolledInput<T>): [T, (value: T) => void, boolean] {
	const [uncontrolledValue, setUncontrolledValue] = React.useState(
		defaultValue !== undefined ? defaultValue : finalValue
	);

	const handleUncontrolledChange = (val: T) => {
		setUncontrolledValue(val);
		onChange?.(val);
	};

	if (value !== undefined) {
		return [value as T, onChange, true];
	}

	return [uncontrolledValue as T, handleUncontrolledChange, false];
}
